module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create-new-token":"Create a new token"},"es":{"create-new-token":"Crea un token nuevo"},"fr":{"create-new-token":"Créer un nouveau token"},"it":{"create-new-token":"Crea un nuovo token"},"pt":{"create-new-token":"Criar um novo token"},"pl":{"create-new-token":"Utwórz nowy token"}}')
  delete Component.options._Ctor
}
